<template>
    <div class="runner-preview-wrapper">
      <v-card class="pa-4 scrollable-card" elevation="0" outlined>
        <div class="d-flex justify-space-between">
          <v-card-title class="flex-grow-1">{{ editorData.name }}</v-card-title>
          <v-btn v-show="isUserSysdev"  @click="deleteDialog" class="mt-2" elevation="0" color="text-capitalize error">Delete</v-btn>
        </div>
        <div class="json-editor-wrapper">
          <vue-json-editor
            v-model="editorData"
            mode="code"
            @change="handleDataChange"
            :expanded-on-start="true"
          ></vue-json-editor>
        </div>
        <v-card-actions class="ml-0 pl-0 mt-0 pt-6">
          <v-spacer></v-spacer>
            <v-btn width="120" elevation="0" color="text-capitalize gray" @click="cancelModal">Cancel</v-btn>
            <v-btn :disabled="!isUserSysdev"  width="120"   elevation="0" color="text-capitalize primary" @click="updateRunner">Save</v-btn>
          </v-card-actions>
      </v-card>
      <v-dialog v-model="isDeleteDialog" width="400">
      <v-card class="pa-5">
            <v-row class="pl-5 pr-3">
          <v-card-title>Delete application</v-card-title>
          <v-card-actions class="ml-auto"><v-btn @click="deleteDialog" icon><v-icon>{{ icons.mdiClose }}</v-icon></v-btn></v-card-actions>
        </v-row>
            <v-card-text class="text-secondary">
              Are you sure you want to delete <b></b> application?
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  class="cnl-btn px-8"
                  text
                  @click="deleteDialog"
              >Cancel
              </v-btn>
              <v-btn
                  class="red-btn px-8 ml-6"
                  text
                  @click="deleteRunner"
                 >
                Delete
              </v-btn>
            </v-card-actions>
          </v-card>
    </v-dialog>
    </div>
  </template>
  
  <script>
  import VueJsonEditor from 'vue-json-editor';
  import { mapActions, mapGetters } from 'vuex';
  import { mdiClose } from '@mdi/js';
  import Applications from '../../services/api/Applications';

  
  export default {
    name: "RunnerPreview",
    components: { VueJsonEditor },
    props: ['runnerId'],
    data() {
      return {
        isDeleteDialog: false,
        editorData: {}, // This will be bound to the JSON editor
        initialApplicationData: {},
        changesOnApp: {},
        currentPage: 1,
        pageSize: 35,
        icons: {
          mdiClose: mdiClose
        },
      };
    },
    computed: {
      ...mapGetters('runners', ['getCurrentRunner']),
      ...mapGetters('accounts', ['getUser']),
        isUserSysdev(){
          return this.getUser.sys_dev;
        }
    },
    watch: {
      runnerId: {
        immediate: true,
        handler(newVal) {
          this.fetchRunnersData(newVal);
        }
      },
      getCurrentRunner: {
        immediate: true,
        handler(newVal) {
          if (newVal) {
            this.editorData = JSON.parse(JSON.stringify(newVal));
            this.initialApplicationData = JSON.parse(JSON.stringify(newVal));
          }
        }
      }
    },
    mounted() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.fixEditorHeight();
        }, 100);
      });
      // Also fix on window resize
      window.addEventListener('resize', this.fixEditorHeight);
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.fixEditorHeight);
    },
    methods: {
      fixEditorHeight() {
        const editorWrapper = this.$el?.querySelector('.json-editor-wrapper');
        const jsonEditorVue = this.$el?.querySelector('.jsoneditor-vue');
        const jsonEditor = this.$el?.querySelector('.jsoneditor');
        
        if (editorWrapper && jsonEditorVue && jsonEditor) {
          const wrapperHeight = editorWrapper.offsetHeight;
          // Set explicit pixel height on the elements that don't respect flex
          jsonEditorVue.style.height = wrapperHeight + 'px';
          jsonEditor.style.height = wrapperHeight + 'px';
        }
      },
      ...mapActions('runners', ['getRunner', 'setRunners']),
      fetchRunnersData(runnerId){
        this.getRunner(runnerId);
      },
      deleteDialog(){
        this.isDeleteDialog = !this.isDeleteDialog;
      },
      cancelModal(){
        this.$router.push('/runners');
      },
      deleteRunner(){
        let uuid = this.getCurrentRunner.uuid;
        Applications.deleteRunner(uuid).then(()=> {
          this.setRunners(
            {
              page: this.currentPage,
              pageSize: this.pageSize,
              search: this.searchQuery
            }
          );
          this.isdeleteDialog = false;
          this.$router.push('/runners');
        })
      },
      handleDataChange() {
        // This method should be fired every time the JSON editor's content changes
        this.changesOnApp = this.calculateChanges(this.initialApplicationData, this.editorData);
      },
      calculateChanges(original, updated) {
        const changes = {};
        Object.keys(updated).forEach(key => {
          if (JSON.stringify(original[key]) !== JSON.stringify(updated[key])) {
            changes[key] = updated[key];
          }
        });
        return changes;
      },
      updateRunner(){
        Applications.updateRunner(this.runnerId, this.editorData)
        .then(()=> {
          this.setRunners(
            {
              page: this.currentPage,
              pageSize: this.pageSize,
              search: this.searchQuery
            });
        })
        .catch(error => {
          console.error('Update failed', error);
          this.$emit('updateError', error);
        });
      }
    }
  }
  </script>
  
  <style>
  .runner-preview-wrapper {
    height: 95vh;
    display: flex;
    flex-direction: column;
  }

  .scrollable-card {
    height: 95vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .json-editor-wrapper {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .json-editor-wrapper > div {
    flex: 1;
    display: flex;
    flex-direction: column;
    height: 100% !important;
  }

  .json-editor-wrapper .jsoneditor-vue {
    flex: 1;
    height: 100% !important;
    display: flex;
    flex-direction: column;
  }

  .json-editor-wrapper .jsoneditor-vue .jsoneditor {
    flex: 1;
    height: 100% !important;
    display: flex;
    flex-direction: column;
  }

  .json-editor-wrapper .jsoneditor-vue .jsoneditor .jsoneditor-outer {
    flex: 1;
    height: 100% !important;
    min-height: 0;
  }

  .json-editor-wrapper .jsoneditor-vue .jsoneditor .ace_editor {
    height: 100% !important;
    min-height: 0;
  }

  .json-editor-wrapper .jsoneditor-vue .jsoneditor .ace_scroller {
    height: 100% !important;
  }

  .v-sheet.v-card {
    border-radius: 0px;
  }
  </style>
  